module.exports = __webpack_public_path__ + "a87d049976d33d303805bd705803fa67.svg";